import React, { useState } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export default function EditableDescription({ story }) {
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(story.description || "");
  const [saving, setSaving] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateDoc(doc(db, "stories", story.id), {
        description: description,
        updatedAt: serverTimestamp()
      });
      setIsEditing(false);
    } catch (err) {
      console.error("Error updating description:", err);
      alert("Failed to update description. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setDescription(story.description || "");
    setIsEditing(false);
  };

  return (
    <div className="mb-4">
      {isEditing ? (
        <div>
          <textarea 
            value={description} 
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Add a description for your story..."
            className="w-full min-h-[80px] p-3 border-2 border-gray-300 rounded-md focus:border-blue-500 focus:outline-none text-gray-600 resize-vertical"
            autoFocus
          />
          <div className="flex gap-2 flex-wrap mt-2">
            <button 
              onClick={handleSave} 
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              {saving ? "Saving..." : "Save"}
            </button>
            <button 
              onClick={handleCancel}
              disabled={saving}
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-3 group">
          <div className="flex-1 min-w-0">
            {description ? (
              <p className="text-gray-600 whitespace-pre-wrap">
                {description}
              </p>
            ) : (
              <p className="text-gray-400 italic">
                No description yet. Click "Edit" to add one.
              </p>
            )}
          </div>
          <button 
            onClick={handleEdit} 
            className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md text-sm font-medium flex-shrink-0"
          >
            ✏️ Edit
          </button>
        </div>
      )}
    </div>
  );
}
